// Import everything from autoload folder
import './autoload/_bootstrap.js'; import './autoload/ada-compliance.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import './plugins/google-map';
import './plugins/woocommerce';
import './plugins/notification';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import { Fancybox } from '@fancyapps/ui';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');

  Fancybox.bind('[data-fancybox]');

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /* Scroll next button */
  $(document).on('click', '.js-scroll-next', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let $parent = $(this).closest('section');

    if ($parent.length) {
      $('html, body').animate({ scrollTop: $parent.outerHeight() }, 500);
      return false;
    }
  });

  /**
   * Override bootstrap submenu toggle
   */
  $('.navbar .menu-item-has-children').hover(
    function () {
      if ($(window).width() > 991) {
        $(this).find('.dropdown-menu').addClass('show');
        alignMenuDropdown($(this).children('.dropdown-menu'));
      }
    },
    function () {
      if ($(window).width() > 991) {
        $(this).find('.dropdown-menu').removeClass('show');
      }
    }
  );

  // Dropdown menu mobile toggle
  $('.js-dropdown-toggle').bind('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(window).width() <= 991) {
      $(this).closest('.dropdown').toggleClass('show');
      $('#primary-menu-alt')
        .find('li')
        .removeClass('active')
        .filter('#' + $(this).data('target'))
        .addClass('active');
    }
  });

  // Mobile menu return to first level
  $('.js-dropdown-back').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(e.target).closest('.dropdown').removeClass('show');
    $('#primary-menu-alt').find('li').removeClass('active');
  });

  // Lock body on menu opened
  $('#primary-menu, #webshop-filters')
    .on('show.bs.collapse', function (e) {
      if (!$(e.target).hasClass('js-collapse-filter')) {
        $('body').addClass('lock');
        $('header.header').css('--screen-height', window.innerHeight + 'px');
      }
    })
    .on('hidden.bs.collapse', function (e) {
      if (!$(e.target).hasClass('js-collapse-filter')) {
        $('body').removeClass('lock');
      }
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    // jQuery code goes here
  });

  // Slider control
  $(document).on('click', '.js-slider-toggle', function (e) {
    e.preventDefault();
    let $section = $(this).closest('.s-slider');
    if (!$section.length) return;
    let $slider = $section.find('.js-slider-items');

    if ($slider.length && $(this).data('slide')) {
      switch ($(this).data('slide')) {
        case 'prev':
          $slider.slick('slickPrev');
          break;
        case 'next':
          $slider.slick('slickNext');
          break;
      }
    }
  });

  panelInit();
  sliderInit();
  sliderMobileInit();
  resizeVideo();
}); // end of Document Ready

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here
  setTimeout(function () {
    $('.website-product-gallery-wrapper').removeClass('ajax-overlay--active');
    console.log('loaded + 1sec');
  }, 1000);
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  sliderMobileInit();
  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
let lastScrollTop = 0;
$(window).on('scroll', function () {
  // jQuery code goes here
  let st = $(this).scrollTop();
  $('body')
    .toggleClass('scrolling-top', st < lastScrollTop)
    .toggleClass('scrolling-bottom', st > lastScrollTop)
    .toggleClass('scrolling', st !== 0);
  if (st === 0) $('body').removeClass('scrolling-top scrolling-bottom');
  lastScrollTop = st;
  $('header.header').css('--screen-height', window.innerHeight + 'px');
});

/* Functions */
// Prevent dropdown menu opening out of window
function alignMenuDropdown($dropdown) {
  if ($dropdown === undefined || !$dropdown.length) {
    return false;
  }
  $dropdown.toggleClass(
    'dropdown-menu-left',
    $dropdown.offset().left + $dropdown.width() > $(window).width()
  );
}

function sliderInit() {
  // Usps top
  $(document).find('.js-usps-top:not(.slick-initialized)').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    vertical: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  $('.js-slider-items:not(.slick-initialized)').each(function () {
    $(this).slick({
      dots: false,
      arrows: false,
      slidesToShow: $(this).data('show') ?? 3,
      slidesToScroll: 1,
      swipeToSlide: false,
      speed: 1000,
      autoplay: false,
      infinite: false,
      centerMode: !!$(this).data('center'),
      centerPadding: 0,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  // Related desktop
  $(document)
    .find('.js-md-desktop:not(.slick-initialized)')
    .slick({
      dots: false,
      arrows: false,
      slidesToShow: 3.5,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      infinite: false,
      centerPadding: 0,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 991,
          settings: 'unslick',
        },
      ],
    });
}

function sliderMobileInit() {
  $(document)
    .find('.js-slider-mobile:not(.slick-initialized)')
    .slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      autoplay: false,
      autoplaySpeed: 3000,
      mobileFirst: true,
      centerMode: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 992,
          settings: 'unslick',
        },
      ],
    });

  // Dots slider
  $(document)
    .find('.js-dots-mobile:not(.slick-initialized)')
    .slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      autoplay: false,
      autoplaySpeed: 3000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 992,
          settings: 'unslick',
        },
      ],
    });

  // Usps lite
  $(document)
    .find('.js-usps-lite:not(.slick-initialized)')
    .slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 3000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 992,
          settings: 'unslick',
        },
      ],
    });

  // Instagram
  $(document)
    .find('.js-instagram-mobile:not(.slick-initialized)')
    .slick({
      dots: false,
      arrows: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 3000,
      mobileFirst: true,
      centerMode: true,
      infinite: false,
      centerPadding: 10,
      responsive: [
        {
          breakpoint: 992,
          settings: 'unslick',
        },
      ],
    });

  // Products
  $(document)
    .find('.js-products-mobile:not(.slick-initialized)')
    .slick({
      dots: false,
      arrows: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      autoplay: false,
      autoplaySpeed: 3000,
      mobileFirst: true,
      centerMode: true,
      infinite: false,
      centerPadding: 0,
      responsive: [
        {
          breakpoint: 992,
          settings: 'unslick',
        },
      ],
    });

  // Category children pills
  $(document)
    .find('.js-pills-mobile:not(.slick-initialized)')
    .slick({
      dots: false,
      arrows: false,
      slidesToShow: 6.5,
      slidesToScroll: 1,
      swipeToSlide: true,
      speed: 1000,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      mobileFirst: true,
      centerMode: false,
      centerPadding: 0,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: 'unslick',
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5.5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3.5,
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 2.5,
          },
        },
      ],
    });
}

function panelInit() {
  $(document).on('click', '.js-panel-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    let panel_id = $(this).data('panel');
    let $panel = $(panel_id);
    if ($panel.length) {
      $('body').toggleClass('has-overlay');
      $panel.toggleClass('is-visible');
    }
  });
  $(document).on('click', 'body.has-overlay', function (e) {
    let $target = $(e.target);
    if (!$target.closest('.side-panel').length) {
      $('body').removeClass('has-overlay');
      $('.side-panel').removeClass('is-visible');
    }
  });
}
